import React from "react";
import { Scope } from "informed";

import {
	ColorPicker,
	FileInput,
	GradientInput,
	BorderStylePicker,
	NumberInput,
	ShadowInput,
} from "../../../../../shared/Forms";
import { renderFields } from "../helper";

const Separator = () => {
	const fields = [
		<ColorPicker
			field="backgroundColor"
			id="backgroundColor"
			placeholder="Background Color"
			themeBuilderInputType="ColorPicker"
		/>,
		<FileInput
			field="backgroundImageUrl"
			id="backgroundImageUrl"
			placeholder="Background Image URL"
			themeBuilderInputType="FileInput"
		/>,
		<GradientInput
			field="backgroundGradient"
			id="backgroundGradient"
			placeholder="Background Gradient"
			themeBuilderInputType="GradientInput"
		/>,
		<ColorPicker field="lineColor" id="lineColor" placeholder="Line Color" themeBuilderInputType="ColorPicker" />,
		<BorderStylePicker
			field="lineStyle"
			id="lineStyle"
			placeholder="Line Style"
			themeBuilderInputType="BorderStylePicker"
		/>,
		<NumberInput field="lineWidth" id="lineWidth" placeholder="Line Width" themeBuilderInputType="NumberInput" />,
		<ShadowInput
			field="lineShadow"
			id="lineShadow"
			placeholder="Line Shadow"
			themeBuilderInputType="ShadowInput"
		/>,
		<NumberInput
			field="paddingVertical"
			id="paddingVertical"
			placeholder="Vertical Padding"
			themeBuilderInputType="NumberInput"
		/>,
		<NumberInput
			field="paddingHorizontal"
			id="paddingHorizontal"
			placeholder="Horizontal Padding"
			themeBuilderInputType="NumberInput"
		/>,
	];
	return (
		<div className="theme-columns">
			<Scope scope="separator">
				<div className="theme-column">
					<h4 className="header">Separator</h4>
					<div className="theme-content">{renderFields(fields)}</div>
				</div>
			</Scope>
		</div>
	);
};

export default Separator;
